<template>
    <v-list-item v-if="currencies.length > 1" class="currency-switcher pa-0">
        <v-menu v-model="menu" :close-on-content-click="false" max-height="200" content-class="currency-switcher-menu">
            <template v-slot:activator="{props}">
                <v-list-item class="currency-switcher__label-item" v-bind="props">
                    <v-list-item-title>
                        <div class="d-flex align-center">
                            <span class="currency-switcher__text font-weight-medium text-uppercase text-subtitle-2">
                                {{ currency }}
                            </span>
                            <v-icon end>mdi-menu-down</v-icon>
                        </div>
                    </v-list-item-title>
                </v-list-item>
            </template>
            <v-list density="compact">
                <v-list-item
                    v-for="currencyCode in currencies"
                    :key="currencyCode"
                    @click="switchCurrency(currencyCode)"
                >
                    <v-list-item-title>{{ currencyCode }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-list-item>
</template>

<script lang="ts">
    import {Vue, Component} from 'vue-facing-decorator'

    @Component
    export class CurrencySwitcher extends Vue {
        menu = false

        switchCurrency(currencyCode) {
            this.menu = false
            persistentStore.SET_CURRENCY(currencyCode)
        }

        get currencies() {
            return Object.values(this.$conf.public.currency.available).filter(currency =>
                Object.keys(runtimeStore.exchangeRates).includes(currency)
            )
        }

        get currency() {
            return persistentStore.currency
        }

        get isMobile() {
            return this.$breakpoint.smAndDown
        }
    }

    export default CurrencySwitcher
</script>
